export default __webpack_public_path__ + "static/media/Emilio_Campos.5397739d.png";